import { Observable } from "rxjs";
import { GetPackageDto, GetPackageResp } from "../usecase/package/get-package/get-package.interface";
import { GetCategoryHaloPackageResp } from "@usecase/package/get-category-halo-package/get-category-halo-package.type";
import { GetHaloPackageDto, GetHaloPackageResp } from "@usecase/package/get-halo-package/get-halo-package.type";
import { PromoType } from "@data/domain/promo.entity";
import { GetPackageDetailDto, GetPackageDetailResp } from "@usecase/package/get-package-detail/get-package-detail.type";

export abstract class PackageRepository {
    abstract GetPackageList(params: GetPackageDto, promoType: PromoType): Observable<GetPackageResp>;
    abstract GetCategoryHaloPackage(): Observable<GetCategoryHaloPackageResp>;
    abstract GetHaloPackage(payload: GetHaloPackageDto): Observable<GetHaloPackageResp>; 
    abstract GetPackageDetail(payload: GetPackageDetailDto): Observable<GetPackageDetailResp>;
}